let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aYGIV")).then(() => parcelRequire('3puEE'));